import { Component } from '@angular/core';

/**
 * Ugla main class
 */
@Component({
	selector: 'ugl-ugla',
	template: ''
})
export class UglaComponent {
	/**
	 * @ignore
	 */
	constructor() {}
}
